export default __webpack_public_path__ + "static/Mother-with-her-newborn-baby-son-sitting-on-bed-a33e36ab157ec81cf852d29ffcf15585.jpg";